import { render } from "./primakass.vue?vue&type=template&id=1de491b4"
import script from "./primakass.vue?vue&type=script&lang=js"
export * from "./primakass.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__